function y(t, { style: o, vars: e }, r, s) {
  Object.assign(t.style, o, s && s.getProjectionStyles(r));
  for (const n in e)
    t.style.setProperty(n, e[n]);
}
export {
  y as renderHTML
};
